import store from '@/store/store'
import app from '@/main'
import { notifyWarning } from '@/layouts/notifies'
import i18n from '@/i18n/i18n'

export default socket => {
  socket.on('invoices', function() {
    store.dispatch('invoice/fetchUnpaidInvoices', {
      skip: 0,
      limit: 100
    })
    app.$router.push({ name: 'invoice-list' })

    notifyWarning(i18n.t('invoices.status_updated'))
  })
}
